import React from 'react';
import { SearchBox } from '../../../flights/overview/ui/FlightsPageContent';
import { ShopDineRelaxScopeToggle } from './ShopDineRelaxScopeToggle';
import { ShopDineRelaxSearch } from './ShopDineRelaxSearch';
import { PoiListScope } from '../domain/models/PoiListScope';
import { AirportCodes } from '../../../../types/airports';

interface IShopDineRelaxSearchWidgetProps {
	activeScope: PoiListScope;
	params: { query?: string };
	setCurrentPageIndex: (currentPageIndex: number) => void;
	airportCode?: AirportCodes;
}

export default function ShopDineRelaxSearchWidget({
	activeScope,
	params,
	setCurrentPageIndex,
	airportCode,
}: IShopDineRelaxSearchWidgetProps) {
	return (
		<SearchBox>
			{airportCode && (
				<>
					<ShopDineRelaxScopeToggle
						activeScope={activeScope}
						setCurrentPageIndex={setCurrentPageIndex}
						airportCode={airportCode}
					/>
					<ShopDineRelaxSearch
						params={params}
						setCurrentPageIndex={setCurrentPageIndex}
						airportCode={airportCode}
					/>
				</>
			)}
		</SearchBox>
	);
}
